export default {
  GLOBAL_HEADER_LANGUAGE_SELECTOR_ICON: '.ws-language-listbox-button .ws-language-flag',
  STATIC_HEADER_LANGUAGE_SELECTOR_ICON:
    '.ws-language-listbox-button .ws-language-flag, .ws-language-select-label .ws-language-flag',
  LANGUAGE_SELECTOR: 'ws-header ws-language-selector',
};
